"use strict";

exports.__esModule = true;
exports.default = percentageFormatter;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

/**
 * Format a value as a percentage number
 *
 * @param {number} value - The number to be formatted as a percentage
 * @returns {string} - The value formatted as a percentage
 */
function percentageFormatter(value) {
  if (typeof value !== 'number') {
    throw new TypeError("value must be a number. provided value: ".concat(value));
  }

  return Math.round(value).toString();
}